import { CoursesMonitoringTable } from "components/monitoring/SectionsMonitoringTable";

export default function Page() {
  return <CoursesMonitoringTable />;
}
